module.exports = __webpack_public_path__ + "img/en_slider_text_a1.8275d8c.f04ded69.png";